import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { Role } from './models/auth/role';
import { UnAuthorizedComponent } from './un-authorized/un-authorized.component';
import { AuthGuard } from './utilities/auth/auth.guard';
import { DataPersistenceGuard } from './utilities/data-persistence/data-persistence.guard';
import { AuthSetupGuard } from './utilities/auth/auth-setup.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((d) => d.DashboardModule),
    canActivate: [MsalGuard,AuthSetupGuard ],
  },
  {
    path: '',
    loadChildren: () =>
      import('./device-management/device-management.module').then(
        (dev) => dev.DeviceManagementModule
      ),
    canActivate: [MsalGuard,AuthSetupGuard],canDeactivate: [DataPersistenceGuard ]
  },

  {
    path: 'deviceDetails',
    loadChildren: () =>
      import('./device-management/device-management.module').then(
        (dev) => dev.DeviceManagementModule
      ),
    canActivate: [MsalGuard,AuthSetupGuard],
    canDeactivate: [DataPersistenceGuard]
  },
  {
    path: 'userManagement',
    loadChildren: () =>
      import('./user-management/user-management.module').then(
        (u) => u.UserManagementModule
      ),
    canActivate: [MsalGuard, AuthGuard], data: { roles: [Role.ADMIN]  }
  },
  {
    path: 'patchManagement',
    loadChildren: () =>
      import('./patch-management/patch-management.module').then(
        (u) => u.PatchManagementModule
      ),
    canActivate: [MsalGuard,AuthSetupGuard]
  },
  {
    path: 'unauth',component:UnAuthorizedComponent,canActivate:[MsalGuard ]
    
  },

    {
    path: '**',
    loadChildren: () =>
      import('./device-management/device-management.module').then(
        (dev) => dev.DeviceManagementModule
      ),    
    data: { queryParamsHandling: 'preserve' }, 
    canActivate: [MsalGuard,AuthSetupGuard]
 
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash:true,
      // Don't perform initial navigation in iframes or popups
      initialNavigation: !BrowserUtils.isInIframe()
        ? 'enabledNonBlocking'
        : 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
